import useAppState from "@saleor/hooks/useAppState";
import useUser from "@saleor/hooks/useUser";
import { checkUserPermissionsCanAccessTenants } from "@saleor/utils/handlers/userHandler";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import { StoreListUrlQueryParams } from "./urls";
import StoreCreate from "./views/StoreCreate";
import StoreEdit from "./views/StoreEdit";
import StoreListComponent from "./views/StoreList/StoreList";

const StoreListView: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substring(1));
  const params: StoreListUrlQueryParams = {
    ...qs
  };

  return <StoreListComponent params={params} />;
};

const StoreEditView: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substring(1));
  const params: any = {
    ...qs
  };

  return <StoreEdit id={decodeURIComponent(id)} params={params} />;
};

const Component = () => {
  const intl = useIntl();
  const user = useUser();

  const [accessCheckComplete, setAccessCheckComplete] = React.useState(false);

  const checkAccessPermission = () => {
    if (!checkUserPermissionsCanAccessTenants(user?.user?.userPermissions)) {
      const [, dispatchAppState] = useAppState();
      dispatchAppState({
        payload: {
          error: "unhandled"
        },
        type: "displayError"
      });
    }
    setAccessCheckComplete(true);
  };

  React.useEffect(() => {
    if (!accessCheckComplete) {
      checkAccessPermission();
    }
  }, [user?.user?.userPermissions]);

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Store List",
          description: "Store List"
        })}
      />

      <Routes>
        <Route path={""} element={<StoreListView />} />
        <Route path={"add"} element={<StoreCreate />} />
        <Route path={":id"} element={<StoreEditView />} />
      </Routes>
    </>
  );
};

export default Component;
